import { computed } from "vue";
import { useI18n } from "vue-i18n";

export function useLocalizedDate() {
    const { locale } = useI18n();

    const localizedDate = computed(() => {
        const date = new Date();
        const day = date.getDate();
        const year = date.getFullYear();
        const monthIndex = date.getMonth();

        if (locale.value === "hy") {
            const monthsHy = [
                "հունվարի",
                "փետրվարի",
                "մարտի",
                "ապրիլի",
                "մայիսի",
                "հունիսի",
                "հուլիսի",
                "օգոստոսի",
                "սեպտեմբերի",
                "հոկտեմբերի",
                "նոյեմբերի",
                "դեկտեմբերի",
            ];
            return `${day} ${monthsHy[monthIndex]}, ${year} թ.`;
        }

        if (locale.value === "ru") {
            const monthsRu = [
                "января",
                "февраля",
                "марта",
                "апреля",
                "мая",
                "июня",
                "июля",
                "августа",
                "сентября",
                "октября",
                "ноября",
                "декабря",
            ];
            return `${day} ${monthsRu[monthIndex]} ${year} г.`;
        }

        const monthsEn = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        return `${monthsEn[monthIndex]} ${day}, ${year}`;
    });

    return {
        localizedDate,
    };
}
